import { Box, Typography } from '@mui/material';
import { formatRemaining, getSlaTone, SlaTone } from '../utils/sla';

const TONE_SX: Record<SlaTone, { color: string; fontWeight: number }> = {
  overdue: { color: 'error.main', fontWeight: 600 },
  soon: { color: 'warning.main', fontWeight: 400 },
  ok: { color: 'success.main', fontWeight: 400 },
};

type SlaTextProps = {
  /** Seconds until the deadline, negative when overdue. `null` means there is no SLA. */
  seconds: Nullable<number>;
  /** Shown when there is no SLA. */
  fallback?: string;
  dueDate?: Nullable<string>;
};

const SlaText = ({ seconds, fallback, dueDate }: SlaTextProps) => (
  <Box sx={{ textAlign: 'right', whiteSpace: 'nowrap', fontVariantNumeric: 'tabular-nums' }}>
    {seconds === null ? (
      fallback ? (
        <Typography variant="body2" color="text.secondary" component="span">
          {fallback}
        </Typography>
      ) : null
    ) : (
      <Typography variant="body2" component="span" sx={TONE_SX[getSlaTone(seconds)]}>
        {formatRemaining(seconds)}
      </Typography>
    )}
    {dueDate ? (
      <Typography variant="caption" color="text.secondary" component="div">
        due {dueDate}
      </Typography>
    ) : null}
  </Box>
);

export default SlaText;
